<template lang="pug">
.header-container(
  :class='[{ active: active }]',
  :style='{ background: background }'
)
  .left
    img.back(:src='leftIcon', @click='goBack')
  .title.mid(:style='{ color }') {{ active && activeTitle ? activeTitle : title }}
  .right
    slot(name='right')
</template>

<script>
import { env, Native } from '@hb/NBridge/lib/h5';

const BLACK_LEFT_ICON = 'https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/a1b25d20-c418-4ce0-9d0a-1c141af18707.svg';
const WHITE_LEFT_ICON = 'https://m.hellobike.com/resource/helloyun/884f8718adcd400ea0401429476f2449/1a8e6b8d-4e61-40ae-b0bc-0d2687f926a5.svg';

export default {
  props: {
    title: {
      type: String,
      default: document.title,
    },
    activeTitle: {
      type: String,
      default: document.title,
    },
    activeColor: {
      type: String,
      default: 'black',
    },
    activeThreshold: {
      type: Number,
      default: 20,
    },
    inactiveColor: {
      type: String,
      default: 'black',
    },
    leftBlackWhenActive: {
      type: Boolean,
      default: true,
    },
    leftBlackWhenInactive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      scrollTop: 0,
    };
  },
  computed: {
    active() {
      return this.scrollTop > this.activeThreshold * 0.75;
    },
    color() {
      if (this.active) {
        return this.activeColor;
      }
      return this.inactiveColor;
    },
    leftIcon() {
      if (this.active) {
        if (this.leftBlackWhenActive) {
          return BLACK_LEFT_ICON;
        }
        return WHITE_LEFT_ICON;
      }
      if (this.leftBlackWhenInactive) {
        return BLACK_LEFT_ICON;
      }
      return WHITE_LEFT_ICON;
    },
    background() {
      return `rgba(255, 255, 255, ${Math.min(20, this.scrollTop)
        / this.activeThreshold})`;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handler);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handler);
  },
  methods: {
    goBack() {
      if (env.isEasyBikeApp) {
        Native.goBack();
      } else {
        this.$router.go(-1);
      }
    },
    handler() {
      const scrolltop = document.documentElement.scrollTop
        || window.pageYOffset
        || document.body.scrollTop;
      this.scrollTop = scrolltop;
    },
  },
};
</script>

<style lang="less" scoped>
.header-container {
  padding: 0.4rem 0.1rem 0;
  width: 100vw;
  height: 0.84rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 50 !important;
  transition: background 0.3s ease;
  background-color: transparent;

  .back {
    width: 0.24rem;
    height: 0.24rem;
  }

  .left {
    flex: 0.5;
    text-align: left;
  }

  .mid {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }

  .title {
    font-size: 0.18rem;
    font-weight: bold;
  }

  .right {
    flex: 0.5;
    text-align: right;
  }
}
</style>
